
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { class_returndata } from 'src/types/class_returndata'; 
import { bmxurl, getAccess } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { users_returndata } from 'src/types/user_returndata';
import { GlobalService } from '../_services/global.service';
import { emailtemplate_returndata } from 'src/types/emailtemplate_returndata';
import { cEmailTemplateRegister, cEmailTemplateRegisterAll } from 'src/types/registeremail';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';


@Component({
  selector: 'app-scheduledsessionregister',
  templateUrl: './scheduledsessionregister.component.html',
  styleUrls: ['./scheduledsessionregister.component.css']
})
export class ScheduledSessionregisterComponent  implements OnInit {
  ListRegistrants: any = [];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  DisabledClass: any;
  checked: boolean = true;
  isDisabled: boolean = true;
  selectedItems: any = [];
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  RegisterTitle: string = "Session Register";
  RegisterTitleScreen: string = "Session Register";
  RegisterDate: string = "";
  RegisterName: string = "";
  ScheduledSessionID: string = "";
  ScheduledSessionDate: string = "";
  ConstructedSessionDate: string = "";
  EmailTemplates: any = [];
  selectedEmailTemplate: any;

  CreateUpdateResponse: any;
  templateValid: boolean = true;
  emailTemplateDate: string = "";
  emailTemplateTime: string = "";

  subjectValid: boolean = true;
  textValid:  boolean = true;
  textValidDT:  boolean = true;

  ExampleEmail: string = "";
  EmailContainsDynamicText: boolean = false;
  DynamicContentButton: string = "";

  ShowDynamicTextEditor: boolean = false;
  dynamicTextArray: any[] = [];
  MasterCopy: string= "";

  EmailSubject: string = "";

  EmailText: string = "";
  backUpText: string = "";

  cols: any[] = [];

  nonspecificregiser: boolean = false;

  //Set when the register was opened from the calendar, so the back button returns there
  //instead of the session list.
  cameFromCalendar: boolean = false;

  constructor(
    private route: ActivatedRoute,private http: HttpClient, private appComp: AppComponent, private router: Router, private messageService: MessageService, private globalService: GlobalService) { 

    }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
        this.ScheduledSessionID = params['id'];
        this.ScheduledSessionDate = params['date'];
    });

    this.cameFromCalendar = this.route.snapshot.queryParamMap.get('from') == 'calendar';

    this.http.get(bmxurl + "/EmailTemplateList/" + this.VenueID + "/false").subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.EmailTemplates = (response as emailtemplate_returndata).data;
      }
      else
      {
        this.messageService.add({severity:'warn', summary:'Response Message', detail: this.httpResponse.messages[0]});
      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates, error: ' + error.messages});
    });

    this.loadgrid(false);

    this.cols = [
        { field: 'name', header: 'Name' },
      ];
  }

  SaveRegister(){
    //do post to save the register#
    
    //Attendance is whatever is ticked at the point of saving. This used to only ever set
    //attended to true, so un-ticking someone was silently dropped and a mistaken tick could
    //never be undone.
    if (this.ListRegistrants != null && this.ListRegistrants.attendees != null) {
      this.ListRegistrants.attendees.forEach((attendee: any) => {
        attendee.attended = this.selectedItems.some((element: any) => element.id === attendee.id);
      });
    }

    let postData = {
      id: this.ListRegistrants.id,
      venueid: this.VenueID,
      scheduledsessionid: this.ScheduledSessionID,        
      scheduledsessiondate: this.ConstructedSessionDate,
      attendees: this.ListRegistrants.attendees,
      startdate: this.ListRegistrants.startdate,
      enddate: this.ListRegistrants.enddate,
      duration: this.ListRegistrants.duration,
      name: this.ListRegistrants.name,
      colour: this.ListRegistrants.colour

    };

    this.http.post<any>(bmxurl + "scheduledsessionregister", postData).subscribe((data: any) => {
      this.httpResponse = data;
      if(this.httpResponse.succeeded == true)
      {
        this.ListRegistrants = this.httpResponse.data;
        this.CompletedLoading = true;
        this.messageService.add({severity:'success', summary: 'Success', detail: 'Register saved successfully!'});
        this.router.navigateByUrl("/scheduledsessions");
      }
      else
      {
        this.messageService.add({severity:'error', summary: 'Error', detail: this.httpResponse.messages[0]});
      }
    });
  }

  Cancel(){
    this.router.navigateByUrl("/scheduledsessions");
  }

  loadgrid(showdisabled: boolean)
  {
    this.bmxurl = bmxurl;

    let urlString = bmxurl + "scheduledsessionregister/" + this.VenueID + "/" + this.ScheduledSessionID + "/" + this.ScheduledSessionDate

    if(this.ScheduledSessionDate == null || this.ScheduledSessionDate == undefined)
    {
      this.nonspecificregiser = true;
      urlString = bmxurl + "scheduledsessionregister/" + this.VenueID + "/" + this.ScheduledSessionID;
    }

    this.http.get<any>(urlString).subscribe((data: any) => {
      this.httpResponse = data;
      if(this.httpResponse.succeeded == true)
      {
        this.ListRegistrants = this.httpResponse.data;

        this.ListRegistrants.attendees.forEach((attendee: any) => {
          if (attendee.attended) {
            this.selectedItems.push(attendee);
          }
        });

        let formattedStartDate = new Date(this.ListRegistrants.startdate);
        let dateDate = formattedStartDate.getDate();
        let monthDate = formattedStartDate.getMonth() + 1; // Months are zero-based
        let yearDate = formattedStartDate.getFullYear();
        let hoursDate = formattedStartDate.getHours();
        let minutesDate = formattedStartDate.getMinutes();
        let formattedDate = (dateDate < 10 ? '0' + dateDate : dateDate).toString() + "/" + (monthDate < 10 ? '0' + monthDate : monthDate).toString() + "/" + yearDate + " " + (hoursDate < 10 ? '0' + hoursDate : hoursDate) + ":" + (minutesDate < 10 ? '0' + minutesDate : minutesDate);

        this.RegisterTitle = "Session Register";
        this.RegisterTitleScreen = "Session Register for " + this.ListRegistrants.name;
        if (!this.nonspecificregiser) {
          this.RegisterTitleScreen += " - " + formattedDate;
        }
        this.RegisterName = this.ListRegistrants.name
        this.RegisterDate = formattedDate;

        this.ConstructedSessionDate = this.httpResponse.data.scheduledsessiondate;
        this.CompletedLoading = true;
      }
      else
      {
        this.messageService.add({severity:'error', summary: 'Error', detail: this.httpResponse.messages[0]});
      }
    });
  }

  exportPdf() {
  const doc = new jsPDF();
  
  // Add title
  doc.setFontSize(14);
  doc.text(this.RegisterTitle, 10, 20);
  doc.setFontSize(12);
  doc.text(this.RegisterDate, 165, 20);
  doc.text(this.RegisterName, 13, 28);

  if(!this.nonspecificregiser)
  {
    const tableData = this.ListRegistrants.attendees.map((attendee: any) => [
      attendee.name,
      "[    ]"

    ]);

    autoTable(doc, {
      head: [['Name', 'Attended']],
      body: tableData,
      startY: 35,
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [66, 139, 202]
      }
    });
  }
  else
  {
      const tableData = this.ListRegistrants.map((attendee: any) => [
      attendee.name,
      "[    ]"

    ]);

    autoTable(doc, {
      head: [['Name', 'Attended']],
      body: tableData,
      startY: 35,
      styles: {
        fontSize: 10,
        cellPadding: 3
      },
      headStyles: {
        fillColor: [66, 139, 202]
      }
    });
  }
  
  doc.save(`session_register_${this.ScheduledSessionDate}.pdf`);
}

  getNumberOfDynamicElements(InString, InWord)
  {
    let count = 0;
    let position = InString.indexOf(InWord);

    while (position !== -1) {
      count++;
      position = InString.indexOf(InWord, position + 1);
    }
    return count;
  }

  returnToList()
  {
    if (this.cameFromCalendar) {
      if (!this.nonspecificregiser && this.ScheduledSessionDate) {
        this.router.navigate(['/scheduledsessioncalendar', this.ScheduledSessionDate]);
      } else {
        this.router.navigate(['/scheduledsessioncalendar']);
      }
      return;
    }

    this.router.navigate(['/scheduledsessions']);
  }

  changeTemplate()
  {
    this.textValid = true;
    this.textValidDT = true; 

    this.dynamicTextArray = [];

    this.http.get(bmxurl + "/emailtemplateexample/" + this.VenueID + "/" + this.selectedEmailTemplate.emailtemplateid).subscribe(response => {
      this.httpResponse = response
      if(this.httpResponse.succeeded)
      {
        this.ExampleEmail = (response as any).data; 

        this.backUpText = this.ExampleEmail;
        this.MasterCopy = this.ExampleEmail;

        this.EmailSubject = this.selectedEmailTemplate.emailsubject;

        let i = this.getNumberOfDynamicElements(this.ExampleEmail, "{{DYNAMICTEXT}}");

        if(i > 0)
        {
          if(i == 1)
          {
            this.DynamicContentButton = "You have a dynamic text area, please click here to edit it.";
          }
          else
          {
            this.DynamicContentButton = "You have " + i + " dynamic text areas, please click here to edit them.";
          }
          
          this.EmailContainsDynamicText = true;

          let indexid = 1
          for(let x = 0; x < i; x++)
          { 
            this.dynamicTextArray.push({text: "", index: indexid});
            indexid++;
            this.ShowDynamicTextEditor = true;
          }
        }
        else
        {
          this.DynamicContentButton = "";
          this.EmailContainsDynamicText = false;
        }

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Not Saved', detail: 'Error getting Email Templates Example, error: ' + error.messages});
    });
  }
  
  SaveText(){
    this.ExampleEmail = this.backUpText;
    this.dynamicTextArray.forEach(element => {

      this.ExampleEmail = this.ExampleEmail.replace("{{DYNAMICTEXT}}", element.text);
    });

    this.EmailText = this.ExampleEmail;
  }

  CancelText()
  {
    this.dynamicTextArray.forEach((element: any) => {
      element.text = "";
    });
  }

  sendEmailToAllMemberss()
  {
    let canaccessemails = localStorage.getItem("BetaEmailing");
    if(canaccessemails != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our messaging system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, this service is free. You can turn this on by going to settings and setting 'Event Beta Emailing' to 'Yes' in the Beta section"});
      return;
    }
    else
    {
      this.templateValid = true

      if(this.selectedEmailTemplate == null)
      {
        this.templateValid = false
      }
      else
      {
        this.templateValid = true

        let emailToSend: cEmailTemplateRegister = new cEmailTemplateRegister();
        emailToSend.venueid = this.VenueID;
        emailToSend.scheduledsessionid = this.ScheduledSessionID;
        emailToSend.ddmmyyyyhhmm = this.ScheduledSessionDate;
        emailToSend.reason = this.selectedEmailTemplate.reason;
        emailToSend.emailcontent = this.ExampleEmail;
        emailToSend.emailsubject = this.EmailSubject;

        
        if (confirm("Are you sure you want to send this email to all registrants?"))
        {
          this.http.post(bmxurl + "sendtemplateregister", emailToSend).subscribe(response => {
            this.CreateUpdateResponse = response
            if(this.CreateUpdateResponse.succeeded)
            {
              this.messageService.add({severity:'success', summary:'Email Sent', detail:'Email successfully sent to all bookings'});
              this.selectedEmailTemplate = null

              this.ShowDynamicTextEditor = false;
            }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Sent', detail: 'An error occurred sending email to all bookings'});
          })
        }
      }
    
    }
  }


  //The Send button on both registers comes here. The dated register targets one occurrence
  //of the session; the undated one has no occurrence to target, so it mails every registrant
  //of the session itself through a different endpoint.
  sendEmailToRegister()
  {
    if(this.nonspecificregiser)
    {
      this.sendEmailToWholeRegister();
    }
    else
    {
      this.sendEmailToAllMemberss();
    }
  }

  sendEmailToWholeRegister()
  {
    let canaccessemails = localStorage.getItem("BetaEmailing");
    if(canaccessemails != "true")
    {
      this.messageService.add({life: 7000, severity:'warn', summary:'Not Allowed', detail:"Our messaging system is in beta mode. You're invited to test it and provide feedback at support@smart-entertainment.co.uk. During the beta phase, this service is free. You can turn this on by going to settings and setting 'Event Beta Emailing' to 'Yes' in the Beta section"});
      return;
    }

    if(this.selectedEmailTemplate == null)
    {
      this.templateValid = false;
      return;
    }

    this.templateValid = true;

    let emailToSend: cEmailTemplateRegisterAll = new cEmailTemplateRegisterAll();
    emailToSend.venueid = this.VenueID;
    emailToSend.scheduledsessionid = this.ScheduledSessionID;
    emailToSend.emailcontent = this.ExampleEmail;
    emailToSend.emailsubject = this.EmailSubject;

    if (confirm("Are you sure you want to send this email to everyone on this register?"))
    {
      this.http.post(bmxurl + "sendtemplateregisterall", emailToSend).subscribe(response => {
        this.CreateUpdateResponse = response;
        if(this.CreateUpdateResponse.succeeded)
        {
          this.messageService.add({severity:'success', summary:'Email Sent', detail:'Email successfully sent to everyone on this register'});
          this.selectedEmailTemplate = null;
          this.ShowDynamicTextEditor = false;
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Sent', detail: this.CreateUpdateResponse.messages[0]});
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Not Sent', detail: 'An error occurred sending email to everyone on this register'});
      })
    }
  }
  }
